var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.30574 8.92276L11.6187 2.60982C12.1251 2.13438 12.1271 1.31982 11.6246 0.841741C11.1466 0.339337 10.3324 0.341171 9.85685 0.847243L4.40724 6.27356L2.14352 4.00985C1.66807 3.50338 0.853512 3.50142 0.375429 4.00394C-0.127103 4.48203 -0.125135 5.29659 0.381332 5.77204L3.53205 8.92276C4.00936 9.43121 4.82843 9.43121 5.30574 8.92276ZM11.2996 1.16757C11.2997 1.16759 11.2997 1.16761 11.2997 1.16763C11.3015 1.16928 11.3033 1.17095 11.305 1.17262C11.3033 1.17093 11.3015 1.16925 11.2996 1.16757ZM11.2619 1.12949C10.9608 0.847015 10.4722 0.859729 10.188 1.16763L4.40707 6.92384L4.40656 6.92333L10.1875 1.16714C10.4718 0.859059 10.9608 0.846509 11.2619 1.12949ZM3.86304 8.60327C3.87528 8.61653 3.8879 8.62925 3.90087 8.64141C3.88808 8.6294 3.87564 8.61685 3.86356 8.60376L0.701351 5.44155C0.701218 5.44143 0.701086 5.44131 0.700953 5.44119L3.86304 8.60327ZM0.695478 5.43607C0.380201 5.13874 0.382159 4.62448 0.701351 4.32984C0.985567 4.02194 1.47414 4.00922 1.77524 4.2917C1.47419 4.00872 0.985209 4.02127 0.700829 4.32935C0.381461 4.62415 0.379677 5.13882 0.695478 5.43607Z",
    fill: "#386F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/green-check.b9051792434932f18e4c08740250cc46.svg";
export { ForwardRef as ReactComponent };